import moment, { DurationInputArg2, Moment } from 'moment';
import { DATE_RANGE_OPTIONS, DATE_RANGE_OPTIONS_STATS } from '../config/base';
import { Dayjs, ManipulateType } from 'dayjs';

export function getLastFullWeekRange() {
  const start = moment().subtract(1, 'week').startOf('week').startOf('day');
  const end = moment().subtract(1, 'week').startOf('week').startOf('day').endOf('week');
  const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
  return {
    raw: {
      start,
      end,
    },
    formatted: {
      start: start.format(DATE_FORMAT),
      end: end.format(DATE_FORMAT),
    },
  };
}

type RangeParam = {
  start: Moment;
  end: Moment;
};

export const getRange = (
  selected: keyof typeof DATE_RANGE_OPTIONS,
  rangeParam?: RangeParam,
  amount = 7,
  unit = 'd',
) => {
  const { dateRange } = DATE_RANGE_OPTIONS[selected] || DATE_RANGE_OPTIONS.today;

  const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

  const range = Object.assign({}, rangeParam);

  const format = (val: Moment) => val.format(DATE_FORMAT).toString();

  const currentStartDate = dateRange.start(range?.start);
  const currentEndDate = dateRange.end(range?.end);

  const result = {
    current: {
      start: format(currentStartDate),
      end: format(currentEndDate),
      rawStart: currentStartDate,
      rawEnd: currentEndDate,
    },
    history: getHistoryRangeEx(currentStartDate, currentEndDate, amount, unit),
  };
  return result;
};

export const getRangeUTC = (
  selected: keyof typeof DATE_RANGE_OPTIONS,
  rangeParam?: RangeParam,
  amount = 7,
  unit = 'd',
) => {
  const { dateRangeUTC } = DATE_RANGE_OPTIONS[selected] || DATE_RANGE_OPTIONS.today;

  const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

  const range = Object.assign({}, rangeParam);

  const format = (val: Moment) => val.format(DATE_FORMAT).toString();

  const currentStartDate = dateRangeUTC.start(range?.start);
  const currentEndDate = dateRangeUTC.end(range?.end);

  const result = {
    current: {
      start: format(currentStartDate),
      end: format(currentEndDate),
      rawStart: currentStartDate,
      rawEnd: currentEndDate,
    },
    history: getHistoryRangeEx(currentStartDate, currentEndDate, amount, unit),
  };

  return result;
};

export const getHistoryRangeEx = (
  currentStartDate: Moment,
  currentEndDate: Moment,
  amount: number,
  unit: string,
) => {
  const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
  const start = moment(currentStartDate).subtract(amount, unit as DurationInputArg2);
  const end = moment(currentEndDate).subtract(amount, unit as DurationInputArg2);

  return {
    start: start.format(DATE_FORMAT),
    end: end.format(DATE_FORMAT),
    rawStart: start,
    rawEnd: end,
  };
};

export type RangeParamStats = {
  start: Dayjs;
  end: Dayjs;
};

export const getRangeStats = (
  selected: keyof typeof DATE_RANGE_OPTIONS_STATS,
  rangeParam?: RangeParamStats,
  amount = 7,
  unit: ManipulateType = 'd',
) => {
  const { dateRange } = DATE_RANGE_OPTIONS_STATS[selected];

  const range = Object.assign({}, rangeParam);

  const currentStartDate = dateRange.start(range?.start);
  const currentEndDate = dateRange.end(range?.end);
  const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
  const format = (val: Dayjs) => val.format(DATE_FORMAT).toString();
  const result = {
    current: {
      start: format(currentStartDate),
      end: format(currentEndDate),
      rawStart: currentStartDate,
      rawEnd: currentEndDate,
    },
    history: getHistoryRangeStats(currentStartDate, currentEndDate, amount, unit),
  };

  return result;
};

export const getHistoryRangeStats = (
  currentStartDate: Dayjs,
  currentEndDate: Dayjs,
  amount: number,
  unit: ManipulateType,
) => {
  const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
  const start = currentStartDate.subtract(amount, unit);
  const end = currentEndDate.subtract(amount, unit);

  return {
    start: start.format(DATE_FORMAT),
    end: end.format(DATE_FORMAT),
    rawStart: start,
    rawEnd: end,
  };
};
